
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-CFA"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.onNameEditPopupClose()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-CFA"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.onNameEditPopupClose()"
      ></button>
    </div>


    <div class="profile-photo-body">
      @if (dialogData.showNameEditError) {
        <div class="name-edit-error show-error-desktop" [innerHTML]="dialogData.nameEditErrorMessage"> </div>
      }
      @if (dialogData.showNameEditError) {
        <div class="name-edit-error show-error-mobile" [innerHTML]="dialogData.nameEditErrorMessageMobile"> </div>
      }
      <div class="full-name-container" [formGroup]="dialogData.fullNameToEdit">
        <div class="name-section">
          <label>First name</label>
          <div class="input-edit-section">
            <input sanitizeInputForm [readonly]="dialogData.showNameEditError" formControlName="firstName" class="name-input-field" maxlength="255"
              placeholder="Click to add a first name" (keypress)="dialogData.onNameInputKeyPress($event)" (paste)="dialogData.onPaste($event)" aria-label = "enter first name" tabindex="0">
              @if (!dialogData.showNameEditError) {
                <span class="name-edit-icon" (click)="dialogData.editIconClickHandler($event)" (keypress)="dialogData.editIconClickHandler($event)"></span>
              }
            </div>
          </div>
          <div class="name-section">
            <label>Middle name</label>
            <div class="input-edit-section">
              <input sanitizeInputForm [readonly]="dialogData.showNameEditError" formControlName="middleName" class="name-input-field" maxlength="255"
                placeholder="Click to add a middle name" (keypress)="dialogData.onNameInputKeyPress($event)" (paste)="dialogData.onPaste($event)" aria-label = "enter middle name" tabindex="0">
                @if (!dialogData.showNameEditError) {
                  <span class="name-edit-icon" (click)="dialogData.editIconClickHandler($event)" (keypress)="dialogData.editIconClickHandler($event)"></span>
                }
              </div>
            </div>
            <div class="name-section">
              <label>Last name</label>
              <div class="input-edit-section">
                <input sanitizeInputForm [readonly]="dialogData.showNameEditError" formControlName="lastName" class="name-input-field" maxlength="255"
                  placeholder="Click to add a last name" (keypress)="dialogData.onNameInputKeyPress($event)" (paste)="dialogData.onPaste($event)" aria-label = "enter last name" tabindex="0">
                  @if (!dialogData.showNameEditError) {
                    <span class="name-edit-icon" (click)="dialogData.editIconClickHandler($event)" (keypress)="dialogData.editIconClickHandler($event)"></span>
                  }
                </div>
              </div>
            </div>
            <div class="btn-container">
              @if (!dialogData.showNameEditError) {
                <button tabindex="0" aria-label="Save" class="send-button"
            [disabled]="!dialogData.fullNameToEdit.dirty || (dialogData.fullNameToEdit.value.firstName == '' 
            && dialogData.fullNameToEdit.value.middleName == '' && dialogData.fullNameToEdit.value.lastName == '')" 
                (click)="dialogData.saveFullName()">Save</button>
              }

              @if (dialogData.showNameEditError) {
                <button tabindex="0"  aria-label="Submit" class="send-button"
                (click)="dialogData.sendRequestToCustomerSupport()" (keypress)="dialogData.sendRequestToCustomerSupport()">Submit</button>
              }
              @if (dialogData.showNameEditError) {
                <button tabindex="0"  aria-label="Cancel" class="cancel-button"
                (click)="dialogData.onNameEditPopupClose()">Cancel</button>
              }
            </div>
          </div>



        </div>
      </div>

